import { useState, useEffect, ReactNode } from 'react';
import { MobileContextType } from './MobileContext.types';
import { MobileContext } from './MobileContext.context';

interface MobileProviderProps {
  children: ReactNode;
  mobileBreakpoint?: number;
}

export function MobileProvider({ children, mobileBreakpoint = 768 }: MobileProviderProps) {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const updateScreenSize = () => {
      const width = window.innerWidth;
      setIsMobile(width < mobileBreakpoint);
    };

    // Initial check
    updateScreenSize();

    // Add event listener
    window.addEventListener('resize', updateScreenSize);

    // Cleanup
    return () => window.removeEventListener('resize', updateScreenSize);
  }, [mobileBreakpoint]);

  const value: MobileContextType = {
    isMobile,
  };

  return <MobileContext.Provider value={value}>{children}</MobileContext.Provider>;
}
